import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

const DIRECTION = {
	UP: 'up',
	DOWN: 'down',
};
export const SortDirectionIcon = ({size, color, onClick, direction, updated}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '15';
			default:
				return '11';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '15';
			default:
				return '11';
		}
	};

	const getWidthUpdated = size => {
		switch (size) {
			case SIZE.SMALL:
				return '4';
			case SIZE.STANDARD:
				return '8';
			default:
				return '8';
		}
	};
	const getHeightUpdated = size => {
		switch (size) {
			case SIZE.SMALL:
				return '3';
			case SIZE.STANDARD:
				return '6';
			default:
				return '6';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	if (updated) {
		return (
			<StyledSpan
				onClick={handleClick}
				width={getWidthUpdated(size)}
				height={getHeightUpdated(size)}
				color={color}
				updated
			>
				<svg
					width={getWidthUpdated(size)}
					height={getHeightUpdated(size)}
					viewBox="0 0 8 6"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					{direction === DIRECTION.UP && (
						<path
							d="M0.839844 4.535L1.80484 3.57L3.73484 1.64C3.80509 1.56965 3.90043 1.53012 3.99984 1.53012C4.09926 1.53012 4.1946 1.56965 4.26484 1.64L6.19484 3.57L7.15984 4.535"
							stroke={color}
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					)}
					{direction === DIRECTION.DOWN && (
						<path
							d="M0.839844 4.535L1.80484 3.57L3.73484 1.64C3.80509 1.56965 3.90043 1.53012 3.99984 1.53012C4.09926 1.53012 4.1946 1.56965 4.26484 1.64L6.19484 3.57L7.15984 4.535"
							stroke={color}
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
							transform="scale(1, -1) translate(0, -6)"
						/>
					)}
				</svg>
			</StyledSpan>
		);
	} else {
		return (
			<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
				<svg
					width={getWidth(size)}
					height={getHeight(size)}
					fill={color}
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					{direction === DIRECTION.UP && (
						<>
							<path d="M7 14l5-5 5 5z" />
							<path d="M0 0h24v24H0z" fill="none" />
						</>
					)}
					{direction === DIRECTION.DOWN && (
						<>
							<path d="M7 10l5 5 5-5z" />
							<path d="M0 0h24v24H0z" fill="none" />
						</>
					)}
				</svg>
			</StyledSpan>
		);
	}
};

SortDirectionIcon.DIRECTION = DIRECTION;
SortDirectionIcon.SIZE = SIZE;
SortDirectionIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	direction: PropTypes.oneOf([DIRECTION.UP, DIRECTION.DOWN]),
	updated: PropTypes.bool,
};

SortDirectionIcon.defaultProps = {
	direction: DIRECTION.UP,
};
export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};

	svg {
		path {
			stroke: ${({color, updated}) => updated && (color ? color : 'currentColor')};
		}
	}
`;
